
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/venueDetails',['Vue'],function(Vue){
        return {
            name:'VenueDetails',
            template:template,
            computed: {
                venueData: function() {
                    return this.$store.state.pmsCheckin.venueDetails;
                }
            },
            mounted: function() {
                this.$store.dispatch('pmsCheckin/fetchVenueDetailsAndRegOptions',this.$globalParameters.venueName);
            }
        }
    })
})('<div class="row-fluid"> <div class="span6"> <img :src="venueData.VenueImage" alt="Image of Venue"/> </div> <div class="span6 textRight"> <strong class="blueText">{{venueData.Venue}}</strong> <div class="address"> <p>{{venueData.Address}}</p> <p>{{venueData.City}}, {{venueData.StateProv}}, {{venueData.Country}} {{venueData.PostalCode}}</p> </div> <div class="contact"> <p>{{localization.eReg.venueDetailsTelephoneLabel}} {{venueData.PhoneNumber}} | {{localization.eReg.venueDetailsFaxLabel}} {{venueData.FaxNumber}}</p> <p>{{venueData.EmailAddress}}</p> <p>{{venueData.WebAddress}}</p> </div> </div> </div>');
